/**
 * Remotes this host can load. Each key must match the `name` in that remote's
 * federation.config.mjs, and each value must be where its build publishes remoteEntry.json.
 */
export const REMOTES = {
    mfeMessages: 'mfe-messages',
} as const;

/**
 * Passed to initFederation in main-mfe.ts, which fetches each remoteEntry.json up front and
 * folds the remote's shared packages into the host's import map. Only the metadata is fetched
 * here - a remote's exposed code isn't downloaded until something calls loadRemoteModule.
 *
 * A remote that can't be reached is skipped with a warning rather than failing the host's
 * bootstrap (strictRemoteEntry defaults to false), so a remote that isn't running locally
 * breaks only the route that needs it.
 */
export function remoteManifest(): Record<string, string> {
    const isLocalDev = window.location.hostname === 'localhost';
    return {
        // Local dev server (started alongside the host by npm start) when running locally; otherwise the remote is
        // same-origin at a fixed path. Set mfeMessagesRemoteEntry in config.js to override either case.
        [REMOTES.mfeMessages]:
            window.APP_CONFIG?.mfeMessagesRemoteEntry ??
            (isLocalDev ? 'http://localhost:4202/remoteEntry.json' : `${window.location.origin}/${REMOTES.mfeMessages}/remoteEntry.json`),
    };
}
